import { render, staticRenderFns } from "./MatterPreview.vue?vue&type=template&id=41d61f3a&scoped=true"
import script from "./MatterPreview.vue?vue&type=script&lang=js"
export * from "./MatterPreview.vue?vue&type=script&lang=js"
import style0 from "./MatterPreview.vue?vue&type=style&index=0&id=41d61f3a&prod&lang=scss&scoped=true"
import style1 from "./MatterPreview.vue?vue&type=style&index=1&id=41d61f3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d61f3a",
  null
  
)

export default component.exports